/** TorusMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('torusmesh', ['TorusMesh']);
//# sourceMappingURL=index.js.map